export default __webpack_public_path__ + "static/media/warningsign-svgrepo-com.35a22e6a.svg";